<template>
<div>
  <div>
    <span>{{completion.optionContent}}</span>
  </div>

  <div class="form-input">
    <label class="labelStyle" style="width: 70px;">方法检出限:</label>
    <input
      v-model="completion.theoryValue"
      type="number"
      class="input"
      @input="onInput"
    />
    <span>{{completion.unit}}</span>
  </div>
  <div class="form-input">
    <label class="labelStyle" style="width: 70px;">测试值:</label>
    <input
      v-model="completion.value"
      type="number"
      class="input"
      @input="onInput"
    />
    <span>{{completion.unit}}</span>
    <span
      v-if="isCompleted"
      :style="{color: isQualified ? 'green' : 'red'}"
      class="diff"
    >{{isQualified ? '合格' : '不合格'}}</span>
  </div>
</div>
</template>

<script>
import BaseFormula from '../BaseFormula'

export default {
  name: 'CompareSize',
  extends: BaseFormula,
  getSelected: opt => `设定值:${opt.theoryValue}, 实测值:${opt.value}`,
  computed: {
    theoryValue () {
      let theoryValue = this.completion.theoryValue
      return typeof theoryValue === 'number' ? theoryValue : (theoryValue ? Number(theoryValue) : null)
    },
    realValue () {
      let realValue = this.completion.value
      return typeof realValue === 'number' ? realValue : (realValue ? Number(realValue) : null)
    },
    threshold () {
      return this.completion.threshold
    },
    isCompleted () {
      return typeof this.theoryValue === 'number' && typeof this.realValue === 'number'
    },
    isQualified () {
      return this.compare(this.realValue, this.theoryValue)
    }
  },
  methods: {
    setParam () {
      let completion = this.completion
      completion.isCompleted = this.isCompleted
      completion.isQualified = this.isQualified
    },
    onInput () {
      this.completion.resultValue = this.isQualified | 0
      this.setParam()
      this.$emit('complete-change')
    }
  },
  created () {
    this.setParam()
  }
}
</script>

<style lang="scss" scoped>
.form-input {
  margin-top: 5px;
}

.input {
  margin-left: 10px;
}

.diff {
  margin-left: 22px;
}

.labelStyle {
  display:inline-block;
  text-align: justify;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Completion/Formula/CompareSize.vue